import DetallePersonaDialog from '../components/preregistros/DetallePersonaDialog.vue';
import EstudiosDialog from '../components/preregistros/EstudiosDialog.vue';
import ReferenciasDialog from '../components/preregistros/ReferenciasDialog.vue';

const DIALOG_TYPES = {
  DEFAULT: {
    type: '',
    title: '',
    component: null,
    width: null,
  },

  DETALLE_PREREGISTRO: {
    type: 'detalle-preregistro',
    title: 'Detalle de preregistro',
    component: DetallePersonaDialog,
    width: '80%',
  },

  ESTUDIOS_PREREGISTRO: {
    type: 'estudios-preregistro',
    title: 'Estudios de preregistro',
    component: EstudiosDialog,
    width: '80%',
  },

  REFERENCIAS_PREREGISTRO: {
    type: 'referencias-preregistro',
    title: 'Referencias de preregistro',
    component: ReferenciasDialog,
    width: '80%',
  },
};

export default DIALOG_TYPES;
